import { render, staticRenderFns } from "./KeepFontSizeStyleSheet.vue?vue&type=template&id=46321b07&"
import script from "./KeepFontSizeStyleSheet.vue?vue&type=script&lang=js&"
export * from "./KeepFontSizeStyleSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports